export function replacePlaceholders(base, map = {}, fallbackMap = {}) {
    return base
      .replaceAll("{{CLIENTE_NOMBRE_COMPLETO}}", map.CLIENTE_NOMBRE_COMPLETO || fallbackMap.CLIENTE_NOMBRE_COMPLETO || "_______________________________")
      .replaceAll("{{CLIENTE_LICENCIA}}", map.CLIENTE_LICENCIA || fallbackMap.CLIENTE_LICENCIA || "________________")
      .replaceAll("{{FECHA_NACIMIENTO}}", map.FECHA_NACIMIENTO || fallbackMap.FECHA_NACIMIENTO || "__________")
      .replaceAll("{{FIRMA_NOMBRE}}", map.FIRMA_NOMBRE || fallbackMap.FIRMA_NOMBRE || "_______________________________")
      .replaceAll("{{FECHA_FIRMA}}", map.FECHA_FIRMA || fallbackMap.FECHA_FIRMA || new Date().toLocaleDateString("es-PR"))
      .replaceAll("{{TUTOR_PARENTEZCO}}", map.TUTOR_PARENTEZCO || fallbackMap.TUTOR_PARENTEZCO || "")
      .replaceAll("{{TUTOR_LICENCIA}}", map.TUTOR_LICENCIA || fallbackMap.TUTOR_LICENCIA || "");
  }
  